"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomIndex = exports.getElements = exports.closest = exports.onRowFunction = exports.getSortingFromColumns = exports.collectColumns = exports.collectExpandedRows = exports.collectFilters = exports.getFilteringOptionsByKey = exports.getUpdatedSnapshot = exports.processPaging = exports.getFilteringColumns = exports.setDataKeys = exports.createRowUniqueKey = void 0;

var _constants = require("./constants");

var _utils = require("../../../utils");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var createRowUniqueKey = function createRowUniqueKey(data, index) {
  return "row-".concat(index, ":").concat(Object.values(data).filter(function (i) {
    return _typeof(i) !== 'object' && i !== '';
  }).join());
};

exports.createRowUniqueKey = createRowUniqueKey;

var setDataKeys = function setDataKeys(data) {
  return data.map(function (item, i) {
    return _objectSpread({
      key: createRowUniqueKey(item, i)
    }, item);
  });
};

exports.setDataKeys = setDataKeys;

var getFilteringColumns = function getFilteringColumns(columns) {
  return columns.filter(function (_ref) {
    var titleType = _ref.titleType;
    return titleType !== 'columns';
  }).map(function (_ref2) {
    var key = _ref2.key,
        title = _ref2.title;
    return {
      label: title || key,
      value: key
    };
  });
};

exports.getFilteringColumns = getFilteringColumns;

var onFilter = function onFilter(key, value, record) {
  var hasValue = record[key].toString().indexOf(value.toString()) === 0;

  if (!hasValue && record.children) {
    return record.children.some(function (item) {
      return onFilter(key, value, item);
    });
  }

  return hasValue;
};

var processFiltering = function processFiltering(data, filtering) {
  return data.filter(function (row) {
    return filtering.map(function (_ref3) {
      var key = _ref3.key,
          value = _ref3.value;
      return value.some(function (filterValue) {
        return onFilter(key, filterValue, row);
      }) || !value.length;
    }).every(function (result) {
      return result;
    });
  });
};

var defaultSorting = function defaultSorting(data, _ref4) {
  var key = _ref4.key,
      direction = _ref4.direction;
  return data.sort(function (previous, current) {
    var previousValue = previous[key];
    var currentValue = current[key];

    if (typeof previousValue === 'string') {
      previousValue = previousValue.toLowerCase();
    }

    if (typeof currentValue === 'string') {
      currentValue = currentValue.toLowerCase();
    }

    if (previousValue === undefined || currentValue === undefined) {
      return 0;
    }

    if (previousValue > currentValue) {
      return direction === _constants.SORT_DIRECTION_DESC ? -1 : 1;
    }

    if (previousValue < currentValue) {
      return direction === _constants.SORT_DIRECTION_ASC ? -1 : 1;
    }

    return 0;
  });
};

var processSorting = function processSorting(data, _ref5) {
  var key = _ref5.key,
      direction = _ref5.direction,
      sorter = _ref5.sorter;
  return sorter !== undefined ? sorter(_toConsumableArray(data), {
    key: key,
    direction: direction,
    sorter: sorter
  }) : defaultSorting(_toConsumableArray(data), {
    key: key,
    direction: direction,
    sorter: sorter
  });
};

var processPaging = function processPaging(data, _ref6) {
  var pageSize = _ref6.pageSize,
      targetPage = _ref6.currentPage;
  return data.slice((targetPage - 1) * pageSize, targetPage * pageSize);
};

exports.processPaging = processPaging;

var getUpdatedSnapshot = function getUpdatedSnapshot(_ref7) {
  var data = _ref7.data,
      columns = _ref7.columns,
      sorting = _ref7.sorting,
      filtering = _ref7.filtering,
      paging = _ref7.paging;
  var nextSnapshot = data;

  if (filtering && filtering.length) {
    nextSnapshot = processFiltering(nextSnapshot, filtering);
  }

  if (sorting && sorting.key) {
    var sortingConfig = sorting;

    if (sorting.sorter === undefined) {
      var column = columns.find(function (_ref8) {
        var key = _ref8.key;
        return key === sorting.key;
      });
      sortingConfig = _objectSpread({
        sorter: column.sorter
      }, sorting);
    }

    nextSnapshot = processSorting(nextSnapshot, sortingConfig);
  }

  var total = nextSnapshot.length;

  if (paging && paging.currentPage) {
    nextSnapshot = processPaging(nextSnapshot, paging);
  }

  return {
    data: nextSnapshot,
    total: total
  };
};

exports.getUpdatedSnapshot = getUpdatedSnapshot;

var getFilteringOptionsByKey = function getFilteringOptionsByKey(data, column) {
  var options = data.map(function (item) {
    return {
      label: item[column.key].toString(),
      value: item[column.key]
    };
  });
  return options.filter(function (obj, pos, arr) {
    return arr.map(function (mapObj) {
      return mapObj.value;
    }).indexOf(obj.value) === pos && obj.value !== '';
  });
};

exports.getFilteringOptionsByKey = getFilteringOptionsByKey;

var collectFilters = function collectFilters(columns, data) {
  var filters = columns.filter(function (item) {
    return item.filterable && (!item.filters || item.filters.length === 0);
  }).reduce(function (acc, _ref9) {
    var key = _ref9.key;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, []));
  }, {});

  if (Object.keys(filters).length) {
    data.forEach(function (item) {
      Object.keys(filters).forEach(function (key) {
        filters[key].push({
          label: item[key].toString(),
          value: item[key]
        });
      });
    });
    Object.keys(filters).forEach(function (key) {
      filters[key] = filters[key].filter(function (obj, pos, arr) {
        return arr.map(function (mapObj) {
          return mapObj.value;
        }).indexOf(obj.value) === pos && obj.value !== '';
      });
    });
  }

  return filters;
};

exports.collectFilters = collectFilters;

var collectExpandedRows = function collectExpandedRows(data) {
  return data.filter(function (_ref10) {
    var children = _ref10.children;
    return children && children.length;
  }).map(function (_ref11) {
    var key = _ref11.key;
    return key;
  });
};

exports.collectExpandedRows = collectExpandedRows;

var collectColumns = function collectColumns(columns, data, expandedColumn, expandOnClick, orderColumns, selectionConfig) {
  var filters = collectFilters(columns, data);
  return columns.map(function (item, ind) {
    var filterOptions = item.filterable && {
      filters: item.filters || filters[item.key]
    };
    var sortOptions = item.sortable && {
      sorter: item.sorter || defaultSorting
    };
    var expandedOptions = item.key === expandedColumn ? {
      className: "".concat(item.className || '', " cell-clickable"),
      onCell: function onCell(record, index) {
        return _objectSpread(_objectSpread({}, item.onCell), {}, {
          onClick: function onClick() {
            if (item.onCell && item.onCell.onClick) {
              item.onCell.onClick(record, index);
            }

            if (record.children) expandOnClick(record.key);
          }
        });
      }
    } : {};
    var selectionColumn = ind === 0 && selectionConfig.selectedRowKeys ? {
      selection: selectionConfig.render
    } : {};
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, item), selectionColumn), sortOptions), filterOptions), expandedOptions), {}, {
      onHeaderCell: function onHeaderCell(_ref12) {
        var dragDisabled = _ref12.dragDisabled,
            column = _objectWithoutProperties(_ref12, ["dragDisabled"]);

        var props = typeof item.onHeaderCell === 'function' ? item.onHeaderCell(column) : {};
        if (orderColumns) props.draggable = dragDisabled ? !dragDisabled : true;
        return _objectSpread(_objectSpread({}, props), {}, {
          className: "".concat(props.className || '').concat(item.titleType === 'columns' ? ' cell__select-columns' : '')
        });
      }
    });
  });
};

exports.collectColumns = collectColumns;

var getSortingFromColumns = function getSortingFromColumns(columns) {
  var sortColumn = columns.find(function (item) {
    return item.defaultSortOrder;
  });
  return sortColumn ? {
    key: sortColumn.key,
    direction: sortColumn.defaultSortOrder,
    sorter: sortColumn.sorter
  } : {};
};

exports.getSortingFromColumns = getSortingFromColumns;

var onRowFunction = function onRowFunction(onRow) {
  return function (record, rowIndex) {
    var classNameRow = function classNameRow(row) {
      return (0, _utils.getClassNames)({
        row__selected: row.isSelected
      });
    };

    if (onRow) {
      return _objectSpread(_objectSpread({}, onRow(record, rowIndex)), {}, {
        className: classNameRow(record)
      });
    }

    return {
      className: classNameRow(record)
    };
  };
};

exports.onRowFunction = onRowFunction;

var matches = function matches(element, selector) {
  if (element.matches) return element.matches(selector);
  return element.msMatchesSelector(selector);
};

var closest = function closest(el, selector, rootNode) {
  var element = el;

  while (element) {
    var isRoot = element === rootNode || element === document.body;

    if (isRoot || element.nodeType === 1 && matches(element, selector)) {
      if (isRoot) {
        element = null;
      }

      break;
    }

    element = element.parentNode;
  }

  return element;
};

exports.closest = closest;

var getElements = function getElements(index, selector, rootNode) {
  return rootNode.querySelectorAll("".concat(selector, ":nth-child(").concat(index + 1, ")"));
};

exports.getElements = getElements;

var getDomIndex = function getDomIndex(el) {
  return Array.from(el.parentNode.children).indexOf(el);
};

exports.getDomIndex = getDomIndex;